module.exports = __webpack_public_path__ + "img/white-icon.c6d36601.svg";